module.exports = __webpack_public_path__ + "static/img/loader.4f73042.gif";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/loader.gif
// module id = pJsp
// module chunks = 1